import React, { useEffect, useState } from 'react'
import AccountNavigation from '../Navigation/AccountNavigation'
import { useGetProfile, useGetSkillProgress } from '../../../../hooks';
import { toast } from 'react-toastify';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import { useSelector } from 'react-redux';
import { loggedUser } from '../../../store/features/authSlice';
import ScoreHigh from '../../../../assets/images/svg/ScoreHigh';
import ScoreMedium from '../../../../assets/images/svg/ScoreMedium';
import ScoreLow from '../../../../assets/images/svg/ScoreLow';
import "react-vertical-timeline-component/style.min.css";

const MyUserViewSkillScoreProgress = ({ t }) => {
    const navigate = useNavigate();
    const { skillScoringParametersId } = useParams();

    const checkLoggedInUser = useSelector(loggedUser);

    console.log(checkLoggedInUser,'checkLoggedInUser-----')


    // const { userDataFromChildData } = useOutletContext();
    const [profileData, setProfileData] = useState(null);
    const [data, setData] = useState([]);

    // 🔹 Fetch profile details
    const { isLoading: isLoadingProfile } = useGetProfile(
        ({ data: profile }) => setProfileData(profile),
        (error) => {
            toast.error(error.message);
            if (error?.data?.redirect) navigate('/dashboard');
        }
    );

    // 🔹 Restrict access to only normal users (user_type === 2)
    useEffect(() => {
        if (profileData?.user_type && profileData.user_type !== 2) {
            navigate('/my-profile');
        }
    }, [profileData]);

    // useEffect(() => {
    //     if (userDataFromChildData != null && userDataFromChildData != null && userDataFromChildData?.user_type != 2) {
    //         navigate(`/user/view/details/${id}`);
    //     }
    // }, [userDataFromChildData]);

    let errorHandled = false;
    const handleError = (error) => {
        if (errorHandled) return;
        errorHandled = true;

        if (error?.data?.redirect === true) {
            toast.error(error.message);
            navigate('/dashboard');
        } else {
            toast.error(error.message);
        }

        setTimeout(() => {
            errorHandled = false;
        }, 1000);
    };

    const userId = checkLoggedInUser.user.user_id;
    const { refetch } = useGetSkillProgress(
        userId, skillScoringParametersId,
        (res) => {
            setData(res.data || []);
        },
        handleError
    );

    const getScoreClass = (optionColor) => {
        switch (optionColor) {
            case 1:
                return 'green';
            case 2:
                return 'blue';
            case 3:
                return 'red';
            default:
                return null;
        }
    };

    const getOptionIcon = (optionColor) => {
        switch (optionColor) {
            case 1:
                return <ScoreHigh />;
            case 2:
                return <ScoreMedium />;
            case 3:
                return <ScoreLow />;
            default:
                return null;
        }
    };


    const getImageName = (firstName, lastName) => {
        let imageName = 'US';
        if (firstName) {
            imageName = firstName.substring(0, 1);
        }
        if (lastName) {
            imageName += lastName.substring(0, 1);
        }
        return imageName;
    };

    return (
        <>
            <AccountNavigation
                t={t}
                formatted_joining_date={profileData?.formatted_joining_date}
                formatted_last_working_date={profileData?.formatted_last_working_date}
                data={profileData}
            />
            {/* No data message */}
            {(!data?.user_score || data.user_score.length === 0) ? (
                <div className="no-data-found" style={{ textAlign: "center", padding: "20px" }}>
                    {t('page.no_skills_scoring_option_data')}
                </div>
            ) : (
                <>
                <div className="skill-vertical-chart">
                    <h2 className="chart-title">{data?.skill_parameter?.skill_name}</h2>
                    <VerticalTimeline animate={true} lineColor="#ddd" >
                        {[...(data.user_score || [])].reverse().map((val, index) => {
                            // date values - defensive fallbacks
                            const createdTs = new Date(val.created_at).getTime();
                            const updatedTs = new Date(val.updated_at).getTime();
                            const isEdited = Math.abs(updatedTs - createdTs) > 10000;

                            return (
                                <VerticalTimelineElement
                                    key={index}
                                    className={getScoreClass(val.option_color)}
                                    // Show updatedAt at top (no label) when edited; createdAt below with "Added on"
                                    date={
                                        <>
                                            <span className='edited_timeline_date_label '> {val.updated_fromat_at} <br /></span>
                                            <span className='edited_timeline_date_label desktop'>{isEdited? `${t('page.skills_created_date_on_label')}: ${val.created_format_at}`: ''}</span>
                                        </>
                                    }
                                    icon={getOptionIcon(val.option_color)}
                                >
                                    <div className="box-content">
                                        <span className="score-label">{val.option_name}</span>
                                        <div className="score-comment">{val.note}</div>
                                        {isEdited && <span className='edited_timeline_date_label mobile status-label gray bordered'>{`${t('page.skills_created_date_on_label')}: ${val.created_format_at}`}</span>}
                                        <div className="user-detail">
                                            {val.updated_by?.profile_image && val.updated_by?.profile_image != '' ? (
                                                <img className="user-image" src={val.updated_by?.profile_image} alt={val.updated_by?.full_name} />
                                            ) : (
                                                <div
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title={user.name}
                                                    className="user-icon profileImageWithoutImage">
                                                    {getImageName(val.updated_by?.first_name, val.updated_by?.last_name)}
                                                </div>)}
                                            <span className="user-name">{val.updated_by.full_name}</span>
                                            <div className="user-actions">
                                                {/* {shouldShowRoute('user.skills.and.score.progress.update') && (<button className="edit-btn" onClick={() => handleModalOpen(val)}><img src={`admin/${editIcon}`} alt="edit" /></button>)}
                                                {shouldShowRoute('user.skills.and.score.progress.destroy') && (<button className="delete-btn" onClick={() => handleDeleteUserSkillScore(val.user_skills_scores_id)}><img src={`admin/${deleteIcon}`} alt="delete" /></button>)} */}
                                            </div>
                                        </div>
                                    </div>
                                </VerticalTimelineElement>
                            );
                        })}
                    </VerticalTimeline>
                </div>
                </>
            )}
        </>
    )
}

export default MyUserViewSkillScoreProgress